/**
 * Тур по странице устройств.
 * Знакомит пользователя с основными функциями страницы.
 * ВАЖНО: Тур работает только на больших экранах (>= 769px).
 */
export default {
  id: 'devices-page',
  name: 'help.tours.devices.name',
  description: 'help.tours.devices.description',

  options: {
    showProgress: true,
    allowClose: true,
    stagePadding: 12,
    stageRadius: 8,
  },

  steps: [
    // Шаг 1: Карта
    {
      element: '.map-canvas',
      titleKey: 'help.tours.devices.map.title',
      descriptionKey: 'help.tours.devices.map.description',
      side: 'left',
      align: 'center',
    },
    // Шаг 2: Тулбар карты
    {
      element: '.map-toolbar',
      titleKey: 'help.tours.devices.mapToolbar.title',
      descriptionKey: 'help.tours.devices.mapToolbar.description',
      side: 'bottom',
      align: 'start',
    },
    // Шаг 3: Панель устройств
    {
      element: '.side-panel--left',
      titleKey: 'help.tours.devices.panel.title',
      descriptionKey: 'help.tours.devices.panel.description',
      side: 'left',
      align: 'start',
    },
    // Шаг 4: Поиск устройств
    {
      element: '.device-panel__toolbar .search-bar',
      titleKey: 'help.tours.devices.search.title',
      descriptionKey: 'help.tours.devices.search.description',
      side: 'bottom',
      align: 'center',
    },
    // Шаг 5: Выбор группы устройств
    {
      element: '.device-panel__dropdown',
      titleKey: 'help.tours.devices.groups.title',
      descriptionKey: 'help.tours.devices.groups.description',
      side: 'bottom',
      align: 'start',
    },
    // Шаг 6: Фильтры по статусу
    {
      element: '.device-panel__filters',
      titleKey: 'help.tours.devices.filters.title',
      descriptionKey: 'help.tours.devices.filters.description',
      side: 'bottom',
      align: 'center',
    },
    // Шаг 7: Список устройств
    {
      element: '.device-feed',
      titleKey: 'help.tours.devices.deviceList.title',
      descriptionKey: 'help.tours.devices.deviceList.description',
      side: 'left',
      align: 'start',
    },
    // Шаг 8: Карточка устройства в компактном режиме
    {
      element: '.feed-card:first-of-type',
      titleKey: 'help.tours.devices.deviceCard.title',
      descriptionKey: 'help.tours.devices.deviceCard.description',
      side: 'left',
      align: 'center',
      expandSelector: '.feed-card:first-of-type .feed-card__compact-expand', // Автоматично розгорнути з компактного режиму
    },
    // Шаг 9: Полная карточка (раскрыть детали)
    {
      element: '.feed-card:first-of-type',
      titleKey: 'help.tours.devices.deviceCard.title',
      descriptionKey: 'help.tours.devices.deviceCard.description',
      side: 'left',
      align: 'center',
      expandSelector: '.feed-card:first-of-type .feed-card__expand-btn', // Автоматично розгорнути деталі
    },
    // Шаг 10: Детальная телеметрия (иконки статусов)
    {
      element: '.feed-card__stats',
      titleKey: 'help.tours.devices.telemetry.title',
      descriptionKey: 'help.tours.devices.telemetry.description',
      side: 'left',
      align: 'start',
    },
    // Шаг 11: Секция датчиків (розгорніть для перегляду)
    {
      element: '.feed-card__sensors-bar',
      titleKey: 'help.tours.devices.sensors.title',
      descriptionKey: 'help.tours.devices.sensors.description',
      side: 'left',
      align: 'center',
    },
    // Шаг 12: Кнопка меню карточки
    {
      element: '.feed-card:first-of-type .feed-card__btn:last-of-type',
      titleKey: 'help.tours.devices.cardMenu.title',
      descriptionKey: 'help.tours.devices.cardMenu.description',
      side: 'left',
      align: 'start',
    },
  ],
}
